<script>
  import { onMount, createEventDispatcher } from "svelte";
  import { Stack } from "creditdesign-svelte-components";
  import { SimpleButton } from "nature-immersive-svelte-components";
  import { allowAnimation } from "./stores/prefers-reduced-motion.js";
  import VisuallyHiddenPoem from "./components/VisuallyHiddenPoem/index.svelte";
  import AnimatedPoem from "./components/AnimatedPoem/index.svelte";
  import data from "./content/data.json";

  let {
    headline,
    standfirst,
    poems,
    prompt,
    source,
    promptHeading,
    outputHeading,
    buttonStartMessage,
    buttonEndMessage,
    buttonNextMessage,
  } = data;

  let poemsFormatted = poems
    .map((d) => d.poem)
    .map((d) => d.replace("\\:", ":"));

  poemsFormatted.unshift(" ");

  let containerElement;
  let mounted = false;
  let poemIndex = 0;
  let buttonMessage = buttonStartMessage;

  $: currentPoem = poemsFormatted[poemIndex];

  let handleClick = () => {
    if (poemIndex < poemsFormatted.length - 1) {
      poemIndex += 1;
    } else {
      poemIndex = 0;
    }

    if (poemIndex === 0) {
      buttonMessage = buttonStartMessage;
    } else if (poemIndex === 9) {
      buttonMessage = buttonEndMessage;
    } else {
      buttonMessage = buttonNextMessage;
    }
  };

  const dispatch = createEventDispatcher();

  onMount(() => {
    mounted = true;

    const QUERY = "(prefers-reduced-motion: no-preference)";
    allowAnimation.set(window.matchMedia(QUERY).matches);

    const ro = new ResizeObserver(([entry]) => {
      dispatch("update");
    });

    ro.observe(containerElement);

    dispatch("update");

    return () => ro.disconnect();
  });
</script>

<style>
  :global(body) {
    font-family: var(--sans-serif-font);
  }

  .container {
    padding-top: var(--s1);
    padding-bottom: var(--s2);
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
  }

  .button-container {
    padding-left: 2px;
  }

  .terminal {
    padding: var(--s1);
    overflow-y: scroll;
    color: #fff;
    background-color: #293845;
  }

  .terminal p {
    margin: 0;
  }

  .code {
    font-family: "SFMono-Regular", Courier, monospace;
  }
</style>

<div class="container" bind:this="{containerElement}">
  <Stack stackSpace="var(--s1)">
    <Stack>
      <h2>{@html headline}</h2>

      <p>{@html standfirst}</p>
    </Stack>

    <Stack>
      <h3 class="code">{@html promptHeading}</h3>
      <div class="terminal code">
        <p>{@html prompt}</p>
      </div>
    </Stack>

    {#if mounted}
      <div class="button-container">
        <SimpleButton on:click="{handleClick}" message="{buttonMessage}" />
      </div>
    {/if}

    <Stack>
      <h3 class="code">
        {#if poemIndex > 0}
          {`${outputHeading}: ${poemIndex} of ${poemsFormatted.length - 1}`}
        {:else}
          {outputHeading}
        {/if}
      </h3>

      <div class="terminal code">
        <VisuallyHiddenPoem
          mounted="{mounted}"
          currentPoem="{currentPoem}"
          poemsFormatted="{poemsFormatted}"
        />

        <AnimatedPoem mounted="{mounted}" currentPoem="{currentPoem}" />
      </div>
    </Stack>
  </Stack>

  <p class="font-size:small">{@html source}</p>
</div>
